<template>
  <div>
    <div v-if="modalComponent">
      <component :is="modalComponent" v-bind="modalProps" @close="hideModal" />
    </div>
    <div v-if="dialogComponent">
      <component
        :is="dialogComponent"
        v-bind="dialogProps"
        @close="hideDialog"
      />
    </div>
  </div>
</template>

<script>
  import { isMobileApp, sendToApp } from "@/utils/utils"

  export default {
    name: "ModalRegistry",
    data() {
      return {
        modalComponent: null,
        modalProps: {},
        dialogComponent: null,
        dialogProps: {},
      }
    },
    watch: {
      modalComponent(newComponent) {
        // Conditionally add or remove overflow hidden based on whether a modal is open
        if (newComponent) {
          this.addBodyOverflowHidden()
          // Conditionally add or remove app header by executing available app method
          this.hideOrShowNativeAppHeader(true)
        } else {
          this.removeBodyOverflowHidden()
          // Conditionally add or remove app header by executing available app method
          this.hideOrShowNativeAppHeader(false)
        }
      },
      dialogComponent(newComponent) {
        // Conditionally add or remove overflow hidden based on whether a modal is open
        if (newComponent) {
          this.addBodyOverflowHidden()
        } else {
          this.removeBodyOverflowHidden()
        }
      },
    },
    created() {
      this.$root.$on("openModal", this.showModal)
      this.$root.$on("closeModal", this.hideModal)
      this.$root.$on("openDialog", this.showDialog)
      this.$root.$on("closeDialog", this.hideDialog)
    },
    beforeDestroy() {
      this.$root.$off("openModal", this.showModal)
      this.$root.$off("closeModal", this.hideModal)
      this.$root.$off("openDialog", this.showDialog)
      this.$root.$off("closeDialog", this.hideDialog)
      this.removeBodyOverflowHidden()
    },
    methods: {
      showModal({ component, props }) {
        this.modalComponent = component
        this.modalProps = props
      },
      hideModal() {
        this.modalComponent = null
        this.modalProps = {}
      },
      showDialog({ component, props }) {
        this.dialogComponent = component
        this.dialogProps = props
      },
      hideDialog() {
        this.dialogComponent = null
        this.dialogProps = {}
      },
      addBodyOverflowHidden() {
        document.body.classList.add("fe-overflow-hidden")
      },
      removeBodyOverflowHidden() {
        document.body.classList.remove("fe-overflow-hidden")
      },
      // This method will be available in native app only, so that's why we are not doing any validation where we need to execute it.
      // When modal opens, we need to hide the app header, for which we need to pass value 2.
      // When modal closes, we need to show the app header back, for which we need to pass value 1.
      // In case of netmeds, we need to send different payload, so using localstorage checker.
      hideOrShowNativeAppHeader(shouldHide) {
        // Netmeds is using this key to find if web view is running in native app
        if (isMobileApp() && localStorage.getItem("__application")) {
          // Top App Bar
          sendToApp({
            type: "updateViews",
            params: {
              type: "appBar",
              hide: shouldHide,
              ...(!shouldHide && {
                hint: "Search for medicines, lab tests, doctors & beauty",
                searchBox: true,
              }),
            },
          })

          // Bottom App Nav Bar
          sendToApp({
            type: "updateViews",
            params: { type: "navBar", hide: shouldHide },
          })
          // this.setSearchBarAppHeader("Search for medicines, lab tests, doctors & beauty")
        } else {
          sendToApp({
            type: "presentHeader",
            value: shouldHide ? 2 : 9,
          })
        }
      },
    },
  }
</script>
